import styles from "pages/replacements-page-styles.module.css";
import { GridLegacy as Grid } from "@mui/material";
import {
	AreYouSureText,
	ItemsWillClearText,
	NoContinueOrdering,
	OrderReplacementsText,
	ReturnToOriginalOrderText
} from "constants/text";
import { useState } from "react";
import { useNavigate } from "react-router";
import LeavePageModal from "components/LeavePageModal/LeavePageModal";
import { useSelector } from "react-redux";
import { RootState } from "stores/application.store";
import { GenerateStepperWrapper } from "./ReplacementHeaderText.styles";
import { LinkButton } from "components/Common/Link";
import ProgressStepper from "../Common/Stepper/Stepper";
import PlaceOrderOriginalOrderDetails from "components/Common/PlaceOrderOriginalOrderDetails/PlaceOrderOriginalOrderDetails";
import { models } from "types/api/viewModels";
import { ReplacementsHeaderWrapper } from "./ReplacementsHeader.styles";
import { useUserLocation } from "hooks/useUserLocation.ts";
import ShoppingCartIcon from "components/Replacements/ShoppingCartIcon/ShoppingCartIcon.tsx";
import SupportCTA from "components/Common/SupportCTA/SupportCTA";
import { getSupportFormUrl } from "utils/supportForm";

export interface ReplacementsHeaderProp {
	orderDetail: models["OrderDetailViewModel"] | null | undefined;
}

const ReplacementsHeader = ({ orderDetail }: ReplacementsHeaderProp) => {
	const { isReplacementsSelectPartsPage } = useUserLocation();

	const cartItems = useSelector((state: RootState) => state.cart.replacements);
	const navigate = useNavigate();
	const [leavePageModalOpen, setLeavePageModalOpen] = useState(false);
	const supportFormUrl = getSupportFormUrl({
		type: "Order Help",
		orderNumber: orderDetail?.orderNumber,
		brand: orderDetail?.configurations?.[0]?.globals?.brand?.description,
		poNumber: orderDetail?.poNumber
	});
	const handleLeavePageModalOpen = (url: string) => {
		if (cartItems && cartItems.length > 0) {
			setLeavePageModalOpen(!leavePageModalOpen);
		} else {
			navigate(url);
		}
	};

	return (
		<ReplacementsHeaderWrapper variant="panel">
			<LeavePageModal
				open={leavePageModalOpen}
				url={`/details/${orderDetail?.orderId}`}
				continueOrdering={() => handleLeavePageModalOpen(`/details/${orderDetail?.orderId}`)}
				closeModal={() => setLeavePageModalOpen(false)}
				headerText={AreYouSureText}
				subHeaderText={ItemsWillClearText}
				continueButtonText={NoContinueOrdering}
			/>
			<Grid
				container
				className={styles.replacementsMainHeader}
			>
				<Grid item>
					<LinkButton
						id="order-details-my-orders-link"
						hasBackIcon
						onClick={() => handleLeavePageModalOpen(`/details/${orderDetail?.orderId}`)}
						data-testid="orderDetailsHeader-myOrdersLink"
					>
						{ReturnToOriginalOrderText}
					</LinkButton>
				</Grid>
				<div style={{ display: "flex", gap: 8, alignItems: "center" }}>
					<SupportCTA
						href={supportFormUrl}
						data-testid="replacements-support-button"
						sx={{
							height: 30,
							minWidth: 175
						}}
					/>
					<ShoppingCartIcon showButtons={isReplacementsSelectPartsPage} />
				</div>
			</Grid>

			<Grid
				container
				className={styles.orderReplacementsHeaderContainer}
			>
				<Grid
					item
					xl={4}
					lg={3.5}
				>
					<h4
						className={styles.replacementPageHeader}
						data-testid="replacements-header-text"
					>
						{OrderReplacementsText}
					</h4>
				</Grid>
				<GenerateStepperWrapper
					container
					xl={8}
					lg={8.5}
					sm={12}
				>
					<ProgressStepper />
				</GenerateStepperWrapper>
			</Grid>
			<PlaceOrderOriginalOrderDetails orderDetail={orderDetail} />
		</ReplacementsHeaderWrapper>
	);
};

export default ReplacementsHeader;
